import { createFileRoute, redirect } from '@tanstack/react-router';

/** @note 未実装のため組織図にリダイレクト */
export const Route = createFileRoute('/_staff/organization/_list/rule-policy/')({
  beforeLoad: () => {
    throw redirect({
      to: '/organization/chart'
    });
  }
});